function isEmptyValue(value: unknown): boolean {
  return value === null || value === undefined || value === "";
}

export function titleizeKey(key: string): string {
  return key
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
}

export function formatNumber(value: unknown, digits = 2): string {
  if (isEmptyValue(value)) return "-";

  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);

  return new Intl.NumberFormat("en-GB", {
    maximumFractionDigits: digits,
    minimumFractionDigits: Number.isInteger(number) ? 0 : digits,
  }).format(number);
}

export function formatPercent(value: unknown): string {
  if (isEmptyValue(value)) return "-";

  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);

  return `${formatNumber(number, 2)}%`;
}

export function formatCurrency(value: unknown): string {
  if (isEmptyValue(value)) return "-";

  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 2,
  }).format(number);
}

export function formatSmartValue(value: unknown): string {
  if (isEmptyValue(value)) return "-";
  if (typeof value === "number") return formatNumber(value);
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}
